export default function initTabs() {
    const toggleElem = document.querySelectorAll('[data-tab]');

    toggleElem.forEach((element) => {
        const ariaControls = element.getAttribute('href');
        const ariaControlsElement = document.querySelector(ariaControls);

        element.addEventListener('click', (event) => {
            event.preventDefault();
            const allActiveTabContents = document.querySelectorAll('[data-tab-content][aria-hidden="false"]');
            const allActiveTabButtons = document.querySelectorAll('[data-tab][aria-expanded="true"]');

            // Hide all tabs, but the clicked one
            allActiveTabContents.forEach((activeTabContent) => {
                activeTabContent.setAttribute('aria-hidden', true);
            });
            ariaControlsElement.setAttribute('aria-hidden', false);

            // Underline only the selected one
            allActiveTabButtons.forEach((activeTabButton) => {
                activeTabButton.setAttribute('aria-expanded', false);
            });
            event.currentTarget.setAttribute('aria-expanded', true);
        });
    });
}
